import { observer } from 'mobx-react';
import { FC } from 'react';
import CrossSellingModalItem from '../../components/CrossSellingModalItem';
import { crossSellingModalStore } from '../../store';
import { IProductV4 } from 'src/types/product';
import { emptyArray } from 'src/utils/helpers';

const CrossSellingModalItems: FC = observer((): JSX.Element | null => {
  const { loading, categories, activeCategory } = crossSellingModalStore;

  if (!loading && !activeCategory?.items?.data.length) return null;

  return (
    <ul className="d-flex flex-column pb-1 gap-30">
      {loading && !categories.length
        ? emptyArray().map((_, index) => <CrossSellingModalItem key={'key-' + String(index)} />)
        : activeCategory?.items.data.map((item: IProductV4) => <CrossSellingModalItem key={item.id} item={item} />)}
    </ul>
  );
});

export default CrossSellingModalItems;
